export const LottieTypes = Object.freeze({
  reward: 'reward',
  spinner: 'spinner',
  tick: 'tick',
  custom: 'custom',
  smallSpinner: 'smallSpinner',
  whiteSpinner: 'whiteSpinner',
});

export const LottieTypesJson = {
  reward: {
    light: () => require('./json/reward.json'),
    dark: () => require('./json/reward.json'),
  },
  spinner: {
    light: () => require('./json/spinner_red.json'),
    dark: () => require('./json/spinner_white.json'),
  },
  tick: {
    light: () => require('./json/tick.json'),
    dark: () => require('./json/tick_white.json'),
  },
  smallSpinner: {
    light: () => require('./json/smallspinner_red.json'),
    dark: () => require('./json/smallspinner_white.json'),
  },
  whiteSpinner: {
    light: () => require('./json/spinner_white.json'),
    dark: () => require('./json/spinner_white.json'),
  },
};
export function setLottieDefaultSource(type, source) {
  switch (type) {
    case LottieTypes.spinner:
    case LottieTypes.smallSpinner:
    case LottieTypes.whiteSpinner:
      LottieTypesJson[type] = source;
      break;
    default:
      break;
  }
}
export function getLottieSource(type, theme, source) {
  switch (type) {
    case LottieTypes.reward:
    case LottieTypes.spinner:
    case LottieTypes.smallSpinner:
    case LottieTypes.tick:
    case LottieTypes.whiteSpinner:
      return LottieTypesJson[type][theme.name]();
    case LottieTypes.custom:
    default:
      return source;
  }
}
